const SNAPMINT_PAYMENT_METHOD = 'Snapmint Express'
const SNAPMINT_SUBMIT_SELECTOR = '.snap_submit_button'
const SNAPMINT_PRESENCE_CHECK_DELAY = 5000

class SnapmintTracking extends CustomElement {
  props = {
    currency: null,
    product: null,
    variant: null,
  }

  cachedVariant = null
  unsubscribeVariantChange = null
  presenceTimer = null

  mounted() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    // Capture phase so a vendor handler that stops propagation cannot hide the click.
    document.addEventListener('click', this.onDocumentClick, true)

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data && event.data.variant
        if (variant) this.cachedVariant = variant
      })
    }

    this.schedulePresenceCheck()
  }

  onDestroy() {
    document.removeEventListener('click', this.onDocumentClick, true)

    if (typeof this.unsubscribeVariantChange === 'function') {
      this.unsubscribeVariantChange()
      this.unsubscribeVariantChange = null
    }

    clearTimeout(this.presenceTimer)
  }

  schedulePresenceCheck() {
    const check = () => {
      this.presenceTimer = setTimeout(() => {
        if (!document.querySelector('#sm-widget-btn')) {
          console.warn('[snapmint-tracking] Snapmint widget (#sm-widget-btn) not found on this page')
        }
      }, SNAPMINT_PRESENCE_CHECK_DELAY)
    }

    if (document.readyState === 'complete') {
      check()
    } else {
      window.addEventListener('load', check, { once: true })
    }
  }

  onDocumentClick(event) {
    try {
      const target = event.target
      const button = target && typeof target.closest === 'function' ? target.closest(SNAPMINT_SUBMIT_SELECTOR) : null
      if (!button) return
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return

      if (typeof window.gtag !== 'function') {
        console.warn('[snapmint-tracking] window.gtag is not available, begin_checkout not sent')
        return
      }

      window.gtag('event', 'begin_checkout', this.buildPayload())
    } catch (error) {
      console.warn('[snapmint-tracking] failed to send begin_checkout', error)
    }
  }

  buildPayload() {
    const payload = { payment_method: SNAPMINT_PAYMENT_METHOD }

    if (this.props.currency) payload.currency = this.props.currency

    const value = this.readOrderValue()
    if (value === null) {
      console.warn('[snapmint-tracking] no valid order value found in the Snapmint widget, sending without value')
    } else {
      payload.value = value
    }

    const item = this.buildItem()
    if (item) payload.items = [item]

    return payload
  }

  parseAmount(raw) {
    if (raw === null || raw === undefined) return null
    const amount = parseFloat(String(raw).replace(/[^0-9.]/g, ''))
    return Number.isFinite(amount) && amount > 0 ? amount : null
  }

  readOrderValue() {
    const widget = document.querySelector('#sm-widget-btn')
    const orderValue = document.querySelector('#Order_value')
    const totalValue = document.querySelector('.total_order_value')

    const candidates = [
      widget && widget.getAttribute('data-widget'),
      orderValue && (orderValue.value || orderValue.textContent),
      totalValue && (totalValue.value || totalValue.textContent || totalValue.getAttribute('data-widget')),
    ]

    for (const raw of candidates) {
      const amount = this.parseAmount(raw)
      if (amount !== null) return amount
    }

    return null
  }

  resolveVariant() {
    const productInfo = this.closest('product-info')
    const picker = productInfo && productInfo.querySelector('variant-radios, variant-selects')

    return (picker && picker.currentVariant) || this.cachedVariant || this.props.variant || null
  }

  readQuantity() {
    const productInfo = this.closest('product-info')
    const input = productInfo && productInfo.querySelector('.quantity__input')
    const quantity = input ? parseInt(input.value, 10) : NaN

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1
  }

  buildItem() {
    const variant = this.resolveVariant()
    if (!variant || typeof variant !== 'object') {
      console.warn('[snapmint-tracking] no variant available, sending without items')
      return null
    }

    const product = this.props.product && typeof this.props.product === 'object' ? this.props.product : {}
    const price = Number(variant.price) / 100
    const variantTitle = variant.public_title && variant.public_title !== 'Default Title' ? variant.public_title : null

    const item = {
      item_id: variant.sku || (product.id !== undefined && product.id !== null ? String(product.id) : null),
      item_name: product.title,
      item_variant: variantTitle,
      price: Number.isFinite(price) ? price : null,
      item_brand: product.vendor,
      quantity: this.readQuantity(),
    }

    Object.keys(item).forEach((key) => {
      if (item[key] === null || item[key] === undefined || item[key] === '') delete item[key]
    })

    return item
  }
}

if (!customElements.get('snapmint-tracking')) {
  customElements.define('snapmint-tracking', SnapmintTracking)
}
